<template>
  <div id="content">
    <div class="header col-md-12">
      <div class="header-inner row align-items-center">
        <div class="col left">
          <div class="title">
            {{ $t('sidebar.goodsreceipt') }}
            <template v-if="ready">
              >
              {{ goodsreceipt.gr_code }}
            </template>
          </div>
        </div>
        <template v-if="device.isMobile">
          <div class="col-7 right pl-0">
            <div
              v-if="goodsreceipt !== null"
              class="action">
              <div
                v-if="showOptionButton"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-secondary shake"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fas fa-cog"/>
                  <span class="name">{{ $t('button.options') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    class="dropdown-item"
                    @click="openCloneModal()">
                    <i class="fas fa-copy"/>
                    <span class="name">{{ $t('button.clone') }}</span>
                  </a>
                  <a
                    class="dropdown-item"
                    @click="openPrintModal()">
                    <i class="fas fa-print"/>
                    <span class="name">{{ $t('button.print') }}</span>
                  </a>
                  <a
                    v-if="hasRoleDelete"
                    class="dropdown-item"
                    @click="openConfirmdeleteModal()">
                    <i class="fas fa-trash text-danger"/>
                    <span class="text-danger">{{ $t('button.delete') }}</span>
                  </a>
                </div>
              </div>
              <!-- status button -->
              <div
                v-if="goodsreceipt.status == 'padding' && hasRoleEdit"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-info"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-circle"/>
                  <span class="name">{{ $t('status.gr.padding') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    class="dropdown-item"
                    @click="openReceivedorderModal()">
                    <i
                      class="far fa-check-circle text-success"
                      style="position: relative; left: -7px;"/>
                    <span class="text-success">{{ $t('status.gr.done') }}</span>
                  </a>
                </div>
              </div>
              <!-- status message -->
              <template v-else>
                <div
                  v-if="goodsreceipt.status == 'padding'"
                  class="dropdown item">
                  <span class="text-info">
                    {{ $t('status.gr.padding') }}
                  </span>
                </div>
                <div
                  v-if="goodsreceipt.status == 'done'"
                  class="dropdown item">
                  <span class="text-success">
                    {{ $t('status.gr.done') }}
                  </span>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="col-7 right">
            <div
              v-if="goodsreceipt !== null"
              class="action">
              <div
                v-if="showOptionButton"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-secondary shake"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fas fa-cog"/>
                  <span class="name">{{ $t('button.options') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    v-if="hasRoleDelete"
                    class="dropdown-item"
                    @click="openConfirmdeleteModal()">
                    <i class="fas fa-trash text-danger"/>
                    <span class="text-danger">{{ $t('button.delete') }}</span>
                  </a>
                </div>
              </div>
              <div
                class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openCloneModal()">
                  <i class="fas fa-copy"/>
                  <span class="name">{{ $t('button.clone') }}</span>
                </button>
              </div>
              <!-- print button -->
              <div class="dropdown nodro item">
                <button
                  class="btn no-bg text-secondary"
                  type="button"
                  @click="openPrintModal()">
                  <i class="fas fa-print"/>
                  <span class="name">{{ $t('button.print') }}</span>
                </button>
              </div>
              <!-- status button -->
              <div
                v-if="goodsreceipt.status == 'padding' && hasRoleEdit"
                class="dropdown item">
                <button
                  id="dropdownMenuButton"
                  class="btn no-bg dropdown-toggle text-info"
                  type="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="far fa-circle"/>
                  <span class="name">{{ $t('status.gr.padding') }}</span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right"
                  aria-labelledby="dropdownMenuButton">
                  <a
                    class="dropdown-item"
                    @click="openReceivedorderModal()">
                    <i
                      class="far fa-check-circle text-success"
                      style="position: relative; left: -7px;"/>
                    <span class="text-success">{{ $t('status.gr.done') }}</span>
                  </a>
                </div>
              </div>
              <!-- status message -->
              <template v-else>
                <div
                  v-if="goodsreceipt.status == 'padding'"
                  class="dropdown item">
                  <span class="text-info">
                    {{ $t('status.gr.padding') }}
                  </span>
                </div>
                <div
                  v-if="goodsreceipt.status == 'done'"
                  class="dropdown item">
                  <span class="text-success">
                    {{ $t('status.gr.done') }}
                  </span>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>

    <div class="content col-md-12">
      <p v-if="!ready">{{ $t('message.loading') }}</p>

      <template v-if="ready">
        <WrapperDoc>
          <template #form>
            <section>
              <div class="col-md-12 no-padding">
                <section-header
                  :title="$t('message.vendor')"
                  :subtitle="$t('series.gr')+' ' + goodsreceipt.gr_code"/>
                <div class="form-row">
                  <div class="col-md-12">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.storecompanyperson') }}</label>
                        <selectize
                          v-model="form.pickedVendorId"
                          :default="form.defaultVendorId"
                          :updateoption="form.updateOptionVendor"
                          :options="form.optionVendors"
                          :multiple="false"
                          :create="true"
                          :loading="form.loadingVendor"
                          :validation="form.trickValidationVendor"
                          :placeholder="$t('placeholder.selectorcreate')"
                          :disabled="disabledForm"
                          @add="onAddedVendor"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="form.pickedVendorId"
                  class="form-row">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.address') }}</label>
                        <textarea
                          v-model="form.vendor.address"
                          :disabled="disabledForm"
                          class="form-control"
                          style="min-height: 107px;"/>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.tel') }}</label>
                        <input
                          v-model="form.vendor.tel"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control">
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.email') }}</label>
                        <input
                          v-model="form.vendor.email"
                          :disabled="disabledForm"
                          type="text"
                          class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <div class="col-md-12 no-padding">
                <section-header :title="$t('message.date')"/>
                <div class="form-row">
                  <div class="col-md-6">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('apps.inventory.message.receiptdate') }}</label>
                        <BaseInputDatePicker
                          v-model="form.selectedDate"
                          :disabled="disabledForm"
                          mode="dateTime"
                          is24hr
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="goodsreceipt.posting_at"
                    class="col-md-6"
                  >
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('apps.inventory.message.postingatreceivedorders') }}</label>
                        <input
                          :class="[{'text-danger': goodsreceipt.posting_at == null}, {'text-success': goodsreceipt.posting_at !== null}]"
                          :disabled="true"
                          :value="goodsreceipt.posting_at ? getDateTime(goodsreceipt.posting_at) : '-'"
                          type="text"
                          class="form-control">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div class="col-md-12 no-padding">
                <section-header :title="$t('apps.inventory.message.shipto')"/>
                <div class="form-row">
                  <div class="col-md-12">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('message.store') }}</label>
                        <select
                          :disabled="true"
                          v-model="form.pickedWarehouseId"
                          class="form-control custom-select">
                          <option
                            v-for="(item, index) in warehouses"
                            :key="index"
                            :disabled="disabledForm"
                            :value="item.warehouse_id">
                            {{ item.warehouse_name }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div class="col-md-12 no-padding">
                <section-header :title="$t('message.orderlist')"/>
                <OrderGR
                  :validation="form.trickValidation"
                  :data="form.orders"
                  :createAble="true"
                  :showProductImage="true"
                  :selectedWhId="form.pickedWarehouseId"
                  :disabled="disabledForm"
                  :optionBinLocations="optionBinLocations"
                  @submit="onSubmitOrder"
                />
              </div>
            </section>

            <section>
              <div class="col-md-12 no-padding">
                <div class="form-row">
                  <div class="col-md-12">
                    <div class="form-group row">
                      <div class="col-md-12">
                        <label>{{ $t('placeholder.note') }}</label>
                        <textarea
                          :placeholder="$t('placeholder.dotted')"
                          v-model="form.note"
                          :disabled="disabledForm"
                          class="form-control"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section
              v-if="!disabledForm"
              class="action-bar"
            >
              <template>
                <div
                  v-if="!$store.state.app.loading"
                  class="col-md-12 text-right">
                  <button
                    class="btn btn-web"
                    @click="form.trickValidation++;">{{ $t('button.save') }}</button>
                </div>
                <div
                  v-else
                  class="col-md-12 text-right">
                  <!-- <button class="btn btn-light btn-block-mobile-only" disabled>{{ $t('button.cancel') }}</button> -->
                  <button
                    class="btn btn-web btn-block-mobile-only"
                    disabled><i class="fas fa-spinner spin"/></button>
                </div>
              </template>
            </section>
          </template>
          <template #ref>
            <DocRef
              :refDoc="`gr`"
              :refId="goodsreceipt.gr_id"
              :refCode="goodsreceipt.gr_code"
              :showLog="getInventorySetting.log_topic.is_active"
              :showAttachFile="getInventorySetting.attach_file.is_active"
              :logTopics="getInventorySetting.log_topic.options"
              :isSubmitted="isSubmitted"
            />
          </template>
        </WrapperDoc>
      </template>
    </div>

    <div
      id="doneModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg-1000"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('apps.inventory.message.receivedorders_header') }}</h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="cancel()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <section class="mb-3">
              <section-title :title="$t('message.productlist')+ ' ('+doneOrders.length+')'"/>
              <div
                v-for="(data, index) in doneOrders"
                :key="index"
                class="col-12 box mb-2">
                <div class="row">
                  <div class="col-12">
                    <div class="form-row">
                      <div class="col-12 col-lg-6 mb-mobile-2">
                        <BaseInput
                          :value="data.item"
                          :disabled="true"/>
                      </div>
                      <div class="col-6 col-lg-3">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">{{ $t('apps.inventory.message.initialdemand') }}</span>
                          </div>
                          <input
                            :value="data.quantity"
                            :disabled="true"
                            type="text"
                            class="form-control text-right number-only text-select-all"
                          >
                        </div>
                      </div>
                      <div class="col-6 col-lg-3">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text">{{ $t('apps.inventory.message.receivedcount') }}</span>
                          </div>
                          <input
                            :disabled="isUseLot(data.sku_id) || isUseSerial(data.sku_id)"
                            v-model="doneOrders[index].done"
                            type="number"
                            class="form-control text-right number-only text-select-all textfield-done"
                            placeholder="0"
                            @change="checkReceivedNumber(doneOrders[index])"
                            @keyup="checkReceivedNumber(doneOrders[index])"
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="isUseLot(data.sku_id) && data.lot_number"
                      class="form-row mt-2"
                    >
                      <div
                        class="col-12"
                        style="margin-bottom: -10px;">
                        <section-title :title="$t('apps.inventory.label.lotnumber')" />
                      </div>
                      <div class="col-12 mt-2">
                        <div class="form-row">
                          <div class="col-6">
                            <div class="row">
                              <div class="col-12 mb-2">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span
                                      class="input-group-text"
                                      style="min-width: 100px;">{{ $t('apps.inventory.label.bin') }}</span>
                                  </div>
                                  <input
                                    :value="getBinName(data.lot_number.bin_location_id)"
                                    :disabled="true"
                                    class="form-control text-right"
                                  >
                                </div>
                              </div>
                              <div class="col-12 mb-2">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span
                                      class="input-group-text"
                                      style="min-width: 100px;">{{ $t('apps.inventory.label.dateproduct') }}</span>
                                  </div>
                                  <input
                                    :value="data.lot_number.date_product ? getDate(data.lot_number.date_product) : null"
                                    :disabled="true"
                                    class="form-control text-right"
                                  >
                                </div>
                              </div>
                              <div class="col-12 mb-2">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span
                                      class="input-group-text"
                                      style="min-width: 100px;">{{ $t('apps.inventory.label.dateexpire') }}</span>
                                  </div>
                                  <input
                                    :value="data.lot_number.date_expire ? getDate(data.lot_number.date_expire) : null"
                                    :disabled="true"
                                    class="form-control text-right"
                                  >
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span
                                      class="input-group-text"
                                      style="min-width: 100px;">{{ $t('apps.inventory.label.cost') }}</span>
                                  </div>
                                  <BaseInputNumber
                                    :value="data.lot_number.cost"
                                    :disabled="true"
                                    class="text-right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="isUseSerial(data.sku_id) && data.serial_numbers"
                      class="form-row mt-2"
                    >
                      <div
                        class="col-12"
                        style="margin-bottom: -10px;">
                        <section-title :title="$t('apps.inventory.label.serialnumber')" />
                      </div>
                      <div
                        v-for="(serial, serIndex) in data.serial_numbers"
                        :key="serIndex"
                        class="col-12 mt-2"
                      >
                        <div class="form-row">
                          <div class="col-6">
                            <div class="row">
                              <div class="col-12 mb-2">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span
                                      class="input-group-text"
                                      style="min-width: 100px;">{{ $t('apps.inventory.label.bin') }}</span>
                                  </div>
                                  <input
                                    :value="getBinName(serial.bin_location_id)"
                                    :disabled="true"
                                    class="form-control text-right"
                                  >
                                </div>
                              </div>
                              <div class="col-12 mb-2">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span
                                      class="input-group-text"
                                      style="min-width: 100px;">{{ $t('apps.inventory.label.serialnumber') }}</span>
                                  </div>
                                  <input
                                    :value="serial.serial_number"
                                    :disabled="true"
                                    class="form-control text-right"
                                  >
                                </div>
                              </div>
                              <div class="col-12 mb-2">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span
                                      class="input-group-text"
                                      style="min-width: 100px;">{{ $t('apps.inventory.label.dateproduct') }}</span>
                                  </div>
                                  <input
                                    :value="serial.date_product ? getDate(serial.date_product) : null"
                                    :disabled="true"
                                    class="form-control text-right"
                                  >
                                </div>
                              </div>
                              <div class="col-12 mb-2">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span
                                      class="input-group-text"
                                      style="min-width: 100px;">{{ $t('apps.inventory.label.dateexpire') }}</span>
                                  </div>
                                  <input
                                    :value="serial.date_expire ? getDate(serial.date_expire) : null"
                                    :disabled="true"
                                    class="form-control text-right"
                                  >
                                </div>
                              </div>
                              <div class="col-12">
                                <div class="input-group">
                                  <div class="input-group-prepend">
                                    <span
                                      class="input-group-text"
                                      style="min-width: 100px;">{{ $t('apps.inventory.label.cost') }}</span>
                                  </div>
                                  <BaseInputNumber
                                    :value="serial.cost"
                                    :disabled="true"
                                    class="text-right"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          v-if="serIndex < data.serial_numbers.length - 1"
                          class="form-row">
                          <div class="col-6">
                            <hr style="margin: 15px 0 5px 0;">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-row mt-2">
                      <div class="col-12">
                        <section-title :title="$t('apps.inventory.message.newresult')" />
                      </div>
                      <div class="col-12">
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              style="border-radius: 0.25em 0 0 0;">
                              {{ getWhLocationName(form.pickedWarehouseId, data.bin_location_id) }}
                            </span>
                          </div>
                          <input
                            :disabled="true"
                            :value="inStockTotal(data.sku_id, data.stock_id, data.bin_location_id)"
                            type="text"
                            class="form-control text-right"
                            style="border-left: 0;border-radius: 0 0.25em 0 0;"
                          >
                        </div>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              style="border-top: 0px;border-radius: 0 0 0 0.25em;">
                              <i class="fas fa-sync-alt"/>
                            </span>
                          </div>
                          <input
                            :class="[
                              'form-control text-right',
                              inStockTotalAfterSubmit(data.sku_id, data.stock_id, data.bin_location_id, doneOrders[index].done) <= -1 ?
                                'text-danger' :
                                '',
                            ]"
                            :disabled="true"
                            :value="inStockTotalAfterSubmit(data.sku_id, data.stock_id, data.bin_location_id, doneOrders[index].done)"
                            type="text"
                            style="border-left: 0px; border-top: 0; border-radius: 0 0 0.25em 0;"
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section>
              <section-title :title="$t('apps.inventory.message.postingatreceivedorders') + ' & ' + $t('message.note')"/>
              <div class="form-row">
                <div class="col-12 col-lg-4 mb-mobile-2">
                  <div class="form-row">
                    <div class="col-12">
                      <div class="input-group">
                        <div
                          class="input-group-prepend"
                          style="max-width: 98px;">
                          <span class="input-group-text text-lowercase">{{ $t('apps.inventory.message.postingatreceivedorders') }}</span>
                        </div>
                        <BaseInputDatePicker
                          v-model="form.posting_at"
                          mode="dateTime"
                          is24hr
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-lg-8">
                  <div class="col-md-12 no-padding">
                    <textarea
                      :placeholder="$t('message.note')"
                      v-model="form.note"
                      class="form-control"
                      style="height: 31px !important;"/>
                  </div>
                </div>
              </div>
            </section>
            <!-- <section class="no-margin" style="background: rgba(203,203,203,.2);padding: 14px 0px 5px;"
                     v-if="showBackOrderHTML">
  						<section-title :title="$t('message.warning')"></section-title>
              <div class="col-md-12 no-padding">
                <div class="row" style="margin-bottom: 12px;">
                  <div class="col-12">
                    <p style="margin-bottom: 8px;">{{ $t('apps.inventory.message.backorderdetail') }}</p>
                    <template v-for="(data, index) in doneOrders">
                    <p class="text-danger" style="margin-bottom: 5px;" v-if="data.done < data.quantity">
                      {{ data.item }} {{  $t('apps.inventory.message.missingcount') }} "{{ data.quantity-data.done }}"
                    </p>
                    </template>
                  </div>
                  <div class="col-12 mt-2">
                    <vs-checkbox color="#A3CA76" style="float: left;margin: 0 10px 0 0;" v-model="form.checkboxBackOrder">
                      {{  $t('message.createbackorderauto') }}
                    </vs-checkbox>
                    <a href="#" target="_blank">{{  $t('button.learnmore') }} <i class="fas fa-external-link-alt"></i></a>
                  </div>
                </div>
              </div>
  					</section> -->
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              data-dismiss="modal"
              @click="cancel()">{{ $t('button.cancel') }}</button>
            <button
              :disabled="form.checkboxRespondBy == false"
              type="button"
              class="btn btn-web"
              @click="done()">{{ $t('button.confirm') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              data-dismiss="modal"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-web"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="confirmdeleteModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="pricesModalTitle"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog "
        role="document">
        <div class="modal-content">
          <div
            class="modal-header"
            style="border-bottom: none;">
            <h5 class="modal-title">
              {{ $t('message.areyousuretodeletethis') }}
            </h5>
            <button
              v-if="!$store.state.app.loading"
              type="button"
              class="close"
              aria-label="Close"
              @click="closeConfirmdeleteModal()">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div
            v-if="!$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              @click="closeConfirmdeleteModal()">{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              @click="del()">{{ $t('button.delete') }}</button>
          </div>
          <div
            v-if="$store.state.app.loading"
            class="modal-footer">
            <button
              type="button"
              class="btn btn-light"
              disabled>{{ $t('button.cancel') }}</button>
            <button
              type="button"
              class="btn btn-danger"
              disabled>
              <i class="fas fa-spinner spin"/>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      id="printModal"
      class="modal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static">
      <div
        class="modal-dialog modal-lg-90-percent"
        role="document">
        <div class="modal-content">
          <div
            class="modal-body p-0"
            style="background: #C9CCCE;height: 660px;overflow: auto;">
            <print-gr
              v-if="ready"
              :goodsreceipt="goodsreceipt"
              class="print-template"/>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-web"
              @click="onclickPrint()">{{ $t('button.print') }}</button>
            <button
              type="button"
              class="btn btn-light"
              @click="closePrintModal()">{{ $t('button.close') }}</button>
          </div>
        </div>
      </div>
    </div>

    <BaseConfirmDiscardModal
      :show="confirmDiscardModal.show"
      @onCancel="handleDiscardCancleModal"
      @onConfirm="handleDiscardConfirmModal"
    />

    <BaseConfirmCloneModal
      :show="modalConfirmClone.show"
      :loading="modalConfirmClone.loading"
      @onClose="handleCloseCloneModal"
      @onCancel="handleCancleCloneModal"
      @onConfirm="handleConfirmCloneModal({
        payload: payloadClone,
        createApiFn: insertGoodsreceipt,
        redirectTo: 'GoodsReceiptAll',
        refCode: 'goodsreceipt.gr_code',
      })"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { toISODateString, toDate } from '@/helpers'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import PrintGr from '@/components/apps/inventory/goodsreceipt/include/PrintGr.vue'
import BaseConfirmCloneModal from '@/components/base/BaseConfirmCloneModal'
import discardFormMixin from '@/mixins/discardForm'
import userPermissionMixin from '@/mixins/userPermission'
import confirmCloneMixin from '@/mixins/confirmClone'
import WrapperDoc from '@/components/combine/WrapperDoc.vue'
import DocRef from '@/components/combine/DocRef.vue'

export default {
  name: 'GoodsReceiptEdit',
  components: {
    PrintGr,
    WrapperDoc,
    DocRef,
    BaseConfirmCloneModal,
  },
  mixins: [discardFormMixin, userPermissionMixin, confirmCloneMixin],
  data () {
    return {
      ready: false,

      doneOrders: [],
      showBackOrderHTML: false,

      form: {
        pickedWarehouseId: null,
        pickedVendorId: null,
        defaultVendorId: null,
        optionVendors: [],
        trickValidationVendor: 0,
        vendor: {
          address: null,
          email: null,
          tel: null,
        },
        updateOptionVendor: null,
        loadingVendor: false,
        note: '',
        selectedDate: new Date(),
        trickValidation: 0,
        orders: [],
        checkboxBackOrder: true,
        checkboxRespondBy: true,
        posting_at: new Date(),
      },

      originalForm: null,

      isCreateAnother: false,

      formats: {
        title: 'MMMM YYYY',
        weekdays: 'WWW',
        navMonths: 'MMM',
        input: null,
        dayPopover: null,
      },

      isSubmitted: false,
    }
  },
  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
      vendor: 'getVendor',
      vendors: 'getVendors',
      getMainWarehouse: 'getMainWarehouse',
      getProductFullNameBySkuId: 'getProductFullNameBySkuId',
      getSkuInfoBySkuId: 'getSkuInfoBySkuId',
      getMainStock: 'getMainStock',
      getWarehouseInfo: 'getWarehouseInfo',
      goodsreceipt: 'getGoodsreceipt',
      dateformat: 'getDateFormat',
      me: 'getMe',
      getPartnerContact: 'getPartnerContact',
      getVendorById: 'getVendorById',
      getDataSetPartnerUpdate: 'getDataSetPartnerUpdate',
      isUseLot: 'isUseLot',
      isUseSerial: 'isUseSerial',
      getBinName: 'getBinName',
      getInventorySetting: 'getInventorySetting',
      getWhLocationName: 'getWhLocationName',
    }),
    disabledForm () {
      return [
        'done',
      ].includes(this.goodsreceipt.status) || !this.hasRoleEdit
    },
    payloadClone() {
      const dataSet = {
      	orders: (() => {
          const orders = []
          for (const order of this.goodsreceipt.orders) {
            const getSku = this.getSkuInfoBySkuId(order.sku_id)
            const stocks = getSku.stocks
            const stock = stocks.find(stock => stock.warehouse_id == this.form.pickedWarehouseId)

            const newOrder = {
              'sku_id': order.sku_id,
              'item': order.item,
              'quantity': order.quantity,
              'stock_id': stock.stock_id,
              'warehouse_id': stock.warehouse_id,
            }

            if (order.lot_number) {
              newOrder.lot_number = {
                'bin_location_id': order.lot_number.bin_location_id,
                'date_expire': order.lot_number.date_expire,
                'cost': order.lot_number.cost,
              }
            }

            if (order.serial_numbers) {
              newOrder.serial_numbers = order.serial_numbers.map((ser) => {
                return {
                  'bin_location_id': ser.bin_location_id,
                  'serial_number': ser.serial_number,
                  'date_expire': ser.date_expire,
                  'cost': ser.cost,
                }
              })
            }

            orders.push(newOrder)
          }
          return orders
        })(),
      	stockin: {
      		warehouse_id: this.goodsreceipt.stockin.warehouse_id,
      		short_name: this.getWarehouseInfo(this.goodsreceipt.stockin.warehouse_id).short_name,
      	},
      	note: this.goodsreceipt.note,
      	po_id: null,
        vendor_id: this.goodsreceipt.vendor.vendor_id,
        scheduled_at: this.goodsreceipt.scheduled_at,
      }
      return dataSet
    },
    defaultOption () {
      return {
        text: this.$t('placeholder.select'),
        value: null,
      }
    },
    optionWarehouses () {
      const items = this.warehouses.map((item) => {
        return {
          text: item.warehouse_name,
          value: item.warehouse_id,
        }
      })
      return items
    },
    optionBinLocations () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.form.pickedWarehouseId) {
          acc.push(...cur.bin_locations)
        }
        return acc
      }, []).map((bin) => {
        return {
          text: bin.code,
          value: bin._id,
        }
      })
      return [{ ...this.defaultOption }, ...items]
    },
  },
  watch: {
    ready: function (isReady) {
      if (isReady) {
        // loading finish
        this.showFinish(this.$Progress)
      }
    },
    warehouses: function (newVal, oldVal) {
      sidebarModule.init(this.getObject(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.update(this.sidebar, 3, [{
        'name': this.$route.query.gr_code,
        'router': {
          'name': 'GoodsIssueEdit',
          'query': {
            'gr_id': this.$route.query.gr_id,
            'gr_code': this.$route.query.gr_code,
          },
        },
        'activeClass': 'active',
      }], {
        sidebarAtIdx: 3,
        submenuAtIdx: 2,
      })
    },
    vendors: function (after, before) {
      this.form.optionVendors = []
      for (let i in after) {
        let vendor = after[i]
        this.form.optionVendors.push({
          text: vendor.vendor_name,
          value: vendor.vendor_id,
        })
      }
    },
    doneOrders: {
      handler: function (newValue) {
        for (let i in this.doneOrders) {
          this.doneOrders[i].done = parseFloat(this.doneOrders[i].done)
        }
      },
      deep: true,
    },
    'form.pickedVendorId': {
      handler: function (after) {
        let vendor_id = after
        let vendorInfo = this.getVendorById(vendor_id)

        this.form.vendor.address = null
        this.form.vendor.email = null
        this.form.vendor.tel = null

        if (vendorInfo) {
          this.form.vendor.address = vendorInfo.address
          this.form.vendor.email = this.getPartnerContact(vendorInfo.contacts).email
          this.form.vendor.tel = this.getPartnerContact(vendorInfo.contacts).tel
        }
      },
      deep: true,
    },
  },
  created: async function () { // call api to get data and set state
    // set date format
    this.formats.input = [this.dateformat + ' HH:mm:ss']
    this.formats.dayPopover = this.dateformat + ' HH:mm:ss'
    // get warehouses
    if (this.warehouses.length == 0) {
      await this.$store.dispatch('getWarehouses')
    }
    /**
     *  validation
     */
    if (!this.$route.query.gr_id) {
      return this.$router.push({ name: 'GoodsReceiptAll' })
    }
    // get category
    let res = await this.$store.dispatch('getGoodsreceipt', {
      gr_id: this.$route.query.gr_id,
    })
    if (!res.success || res.data.length == 0) {
      return this.$router.push({ name: 'GoodsReceiptAll' })
    }
    /**
     *  validation success
     */
    // get vendors
    await this.$store.dispatch('getVendors')

    for (let i = 0; i < this.goodsreceipt.orders.length; i++) {
      const order = this.goodsreceipt.orders[i]
      await this.$store.dispatch('getProductWithMerge', {
        sku_id: order.sku_id,
      })
    }

    // set default
    this.setData()
    // ready
    this.ready = true
  },
  beforeMount: function () { // set states ui
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 4,
      },
    })
    // set sidebar ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.update(this.sidebar, 3, [{
      'name': this.$route.query.gr_code,
      'router': {
        'name': 'GoodsReceiptEdit',
        'query': {
          'gr_id': this.$route.query.gr_id,
          'gr_code': this.$route.query.gr_code,
        },
      },
      'activeClass': 'active',
    }], {
      sidebarAtIdx: 3,
      submenuAtIdx: 2,
    })
    // scroll to top
    $('body,html').animate({
      scrollTop: 0,
    }, 100)
  },
  mounted: function () { // run script
    // set popup modal
    this.setModal('#doneModal')
    this.setModal('#confirmdeleteModal')
    this.setModal('#printModal')
  },
  destroyed: function () { // leave this page
    this.leavePage(this.$Progress, ['clearVendor', 'clearVendors', 'clearProducts'])
  },
  methods: {
    ...mapActions([
      'insertGoodsreceipt',
    ]),
    async onAddedVendor (value) {
      // show loading selectize
      this.form.loadingVendor = true

      // insert new vendor
      let res = await this.$store.dispatch('insertVendor', { name: value })

      if (res.success) {
        let vendor = res.data
        // update option value
        this.form.updateOptionVendor = {
          text: value,
          value: vendor.vendor_id,
          picked: true,
        }
        this.form.optionVendors.push({
          text: value,
          value: vendor.vendor_id,
        })
        // finish loading
        this.showFinish(this.$Progress)
        // hide loading selectize
        this.form.loadingVendor = false
      }
    },
    async clearForm () {
      let that = this

      this.ready = false

      this.form = _.cloneDeep(this.originalForm)

      setTimeout(() => {
        that.ready = true
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }, 100)
    },
    onSubmitOrder (isValid, data) {
      this.isSubmitted = true
      this.form.trickValidationVendor++

      let isInValid = !isValid || (this.form.pickedVendorId == null || this.form.pickedVendorId == '')

      if (isInValid) {
        return $('html, body').animate({ scrollTop: 0 }, 'slow')
      }

      this.update(data)
    },
    async update (data) {
      var orders = []

      for (let i in data) {
        let order = data[i]
        var getSku = this.getSkuInfoBySkuId(order.sku_id)
        var stocks

        if (!getSku) {
          let resGetProduct = await this.$store.dispatch('getProduct', {
            sku_id: order.sku_id,
          })
          let product = resGetProduct.data[0]
          let sku = product.prices.find(sku => sku.sku_id == order.sku_id)
          stocks = sku.stocks
        } else {
          stocks = getSku.stocks
        }

        let stock = stocks.find(stock => stock.warehouse_id == this.form.pickedWarehouseId)

        const newOrder = {
          'sku_id': order.sku_id,
          'item': order.item,
          'quantity': order.quantity,
          'stock_id': stock.stock_id,
          'warehouse_id': stock.warehouse_id,
          'bin_location_id': order.bin_location_id,
        }

        if (order.use_lot) {
          newOrder.lot_number = {
            'bin_location_id': order.lot.binId,
            'date_product': null,
            'date_expire': toISODateString(order.lot.dateExpire),
            'cost': order.lot.cost,
          }
        }

        if (order.use_serial) {
          newOrder.serial_numbers = order.serials.map((ser) => {
            return {
              'bin_location_id': ser.binId,
              'serial_number': ser.serialNumber,
              'date_product': null,
              'date_expire': toISODateString(ser.dateExpire),
              'cost': ser.cost,
            }
          })
        }

        orders.push(newOrder)
      }

      let dataSet = {
        gr_id: this.goodsreceipt.gr_id,
        orders: orders,
        note: this.form.note.trim().length > 0 ? this.form.note.trim() : null,
        po_id: this.goodsreceipt.po_id || null,
        vendor_id: this.form.pickedVendorId,
        scheduled_at: this.form.selectedDate ? this.form.selectedDate.toISOString() : this.moment().toISOString(),
      }

      // update vendor
      let dataSetVendorUpdate = this.getDataSetPartnerUpdate('vendor', this.form.pickedVendorId, this.form.vendor, this.vendors)
      if (dataSetVendorUpdate !== null) {
        await this.$store.dispatch('updateVendor', dataSetVendorUpdate)
        await this.$store.dispatch('getVendors')
      }

      // save data
      var res = await this.$store.dispatch('updateGoodsreceipt', dataSet)

      if (res.success) {
        // get
        await this.$store.dispatch('getGoodsreceipt', {
          gr_id: this.goodsreceipt.gr_id,
        })
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeenupdated', { msg: this.goodsreceipt.gr_code }),
          color: 'success',
          icon: 'cloud',
        })
        // set data
        this.setData()
        this.isSubmitted = false
        // loading finish
        this.showFinish(this.$Progress)
        // scroll to top
        $('html, body').animate({ scrollTop: 0 }, 'slow')
      }
    },
    async done () {
      this.isSubmitted = true

      let data = {
        'gr_id': this.goodsreceipt.gr_id,
        'gr_code': this.goodsreceipt.gr_code,
        'note': this.form.note,
        'orders': [],
        'respond_by': this.me.user_id,
        'posting_at': this.form.posting_at.toISOString(),
      }

      if (this.goodsreceipt.purchases) {
        data['reference'] = {
          po: {
            id: this.goodsreceipt.purchases.po_id,
            code: this.goodsreceipt.purchases.po_code,
          },
        }
      }

      for (let i in this.doneOrders) {
        let order = this.doneOrders[i]
        const newOrder = {
          gro_id: order.gro_id,
          sku_id: order.sku_id,
          stock_id: order.stock_id,
          warehouse_id: order.warehouse_id,
          bin_location_id: order.bin_location_id,
          done: order.done,
          quantity: order.quantity,
        }

        if (order.use_lot) {
          newOrder.lot_number = {
            'bin_location_id': order.lot_number.bin_location_id,
            'date_product': toISODateString(order.lot_number.date_product),
            'date_expire': toISODateString(order.lot_number.date_expire),
            'cost': order.lot_number.cost,
          }
        }

        if (order.use_serial) {
          newOrder.serial_numbers = order.serial_numbers.map((ser) => {
            return {
              'bin_location_id': ser.bin_location_id,
              'serial_number': ser.serial_number,
              'date_product': toISODateString(ser.date_product),
              'date_expire': toISODateString(ser.date_expire),
              'cost': ser.cost,
            }
          })
        }

        data.orders.push(newOrder)
      }

      let res = await this.$store.dispatch('doneGoodsreceipt', data)

      if (res.success) {
        // get goodsreceipt
        await this.$store.dispatch('getGoodsreceipt', {
          gr_id: this.$route.query.gr_id,
        })
        // set data
        this.setData()
        this.isSubmitted = false
        // close modal
        this.closeReceivedorderModal()
        // finish loading
        this.showFinish(this.$Progress)
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeencompleted', { msg: this.goodsreceipt.gr_code }),
          color: 'success',
          icon: 'check',
        })
      }
    },
    cancel () {

    },
    setDefaultOrders () {
      let goodsreceipt = this.goodsreceipt
      let form = this.form

      form.orders = []

      for (let i in goodsreceipt.orders) {
        let order = goodsreceipt.orders[i]
        form.orders.push({
          sku_id: order.sku_id,
          item: order.item,
          description: '',
          quantity: order.quantity,
          price: 0,
          done: order.done,
          selectize: {
            loading: false,
            updateOption: null,
            trickValidation: 0,
          },
          lot: {
            binId: order.lot_number && order.lot_number.bin_location_id,
            dateProduct: order.lot_number && toDate(order.lot_number.date_product),
            dateExpire: order.lot_number && toDate(order.lot_number.date_expire),
            cost: order.lot_number && order.lot_number.cost,
          },
          serials: !order.serial_numbers ? [] : order.serial_numbers.map((ser) => {
            return {
              binId: ser.bin_location_id,
              serialNumber: ser.serial_number,
              dateProduct: toDate(ser.date_product),
              dateExpire: toDate(ser.date_expire),
              cost: ser.cost,
            }
          }),
          use_lot: this.isUseLot(order.sku_id),
          use_serial: this.isUseSerial(order.sku_id),
          bin_location_id: order.bin_location_id,
          queryProductName: order.item,
          image: '',
          is_saving_product: false,
        })
      }
    },
    async setData () {
      let goodsreceipt = this.goodsreceipt
      let form = this.form

      // set general form
      form.defaultVendorId = goodsreceipt.vendor ? goodsreceipt.vendor.vendor_id : null
      form.selectedDate = this.moment(goodsreceipt.scheduled_at).toDate()
      form.pickedWarehouseId = goodsreceipt.stockin.warehouse_id
      form.note = goodsreceipt.note ? goodsreceipt.note : ''

      // set vendor
      this.form.vendor.address = goodsreceipt.vendor.address
      this.form.vendor.email = this.getPartnerContact(goodsreceipt.vendor.contacts).email
      this.form.vendor.tel = this.getPartnerContact(goodsreceipt.vendor.contacts).tel

      // set oders
      this.setDefaultOrders()

      // set originalForm
      this.originalForm = _.cloneDeep(this.form)
    },
    async del () {
      let data = {
        gr_id: this.goodsreceipt.gr_id,
      }

      let res = await this.$store.dispatch('deleteGoodsreceipt', data)

      if (res.success) {
        // show notify
        this.notify(this.$vs, {
          text: this.$t('message.hasbeendeleted', { msg: this.goodsreceipt.gr_code }),
          color: 'danger',
          icon: 'delete',
        })
        // finish loading
        this.showFinish(this.$Progress)
        // close modal
        this.closeConfirmdeleteModal()
        // go to GoodsReceiptAll page
        return this.$router.push({ name: 'GoodsReceiptAll' })
      }
    },
    openConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('show')
    },
    closeConfirmdeleteModal () {
      $('#confirmdeleteModal').modal('hide')
    },
    openReceivedorderModal () {
      this.note = this.goodsreceipt.note
      this.showBackOrderHTML = false
      this.doneOrders = []
      for (let i in this.goodsreceipt.orders) {
        let data = this.goodsreceipt.orders[i]
        this.doneOrders.push({
          gro_id: data.gro_id,
          sku_id: data.sku_id,
          stock_id: data.stock_id,
          warehouse_id: data.warehouse_id,
          bin_location_id: data.bin_location_id,
          item: data.item,
          quantity: data.quantity,
          done: data.quantity,
          lot_number: data.lot_number,
          serial_numbers: data.serial_numbers,
          use_lot: this.isUseLot(data.sku_id),
          use_serial: this.isUseSerial(data.sku_id),
        })
      }

      $('#doneModal').modal('show')

      setTimeout(() => {
        $('.textfield-done').removeClass('text-success text-danger')
        $('.textfield-done').addClass('text-success')
      }, 100)
    },
    closeReceivedorderModal () {
      $('#doneModal').modal('hide')
    },
    checkReceivedNumber (order) {
      let t = this
      let found = false
      for (let i in this.doneOrders) {
        let data = this.doneOrders[i]
        if (data.done < data.quantity) {
          found = true
        }
      }

      this.showBackOrderHTML = found

      $('.textfield-done').each(function (i) {
        let done = parseFloat($(this).val())
        let qty = parseFloat(t.doneOrders[i].quantity)
        $(this).removeClass('text-danger text-success')
        if (done < qty) {
          $(this).addClass('text-danger')
        } else {
          $(this).addClass('text-success')
        }
      })
    },
    onclickPrint () {
      $('.print-template').printThis({
        importStyle: true, // import style tag
      })
    },
    openPrintModal () {
      $('#printModal').modal('show')

      // set modal height
      $('#printModal .modal-body').css({
        height: window.innerHeight - 125 + 'px',
      })

      $('#printModal .modal-body').animate({ scrollTop: 0 }, 0)
    },
    closePrintModal () {
      $('#printModal').modal('hide')
    },
    inStockTotal (sku_id, stock_id, binId) {
      try {
        const sku = this.getSkuInfoBySkuId(sku_id)
        const instock = sku.stocks
          .find((stock) => stock.stock_id === stock_id).stock_locations
          .find((stockLocation) => stockLocation.bin_location_id == binId).instock
        return instock != null
          ? instock
          : 0
      } catch (e) {
        return 0
      }
    },
    inStockTotalAfterSubmit (sku_id, stock_id, binId, newValue) {
      const total = this.inStockTotal(sku_id, stock_id, binId)
      return total + newValue
    },
  },
}
</script>

<style scoped>
.box {
  padding: 15px;
  background: #F5F5F5;
}
.box:last-of-type {
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/goodsreceipt/Edit.vue